import { API_ENDPOINTS } from "@/constants/api";
import { http } from "@/lib/http-client";
import { unwrapData } from "@/lib/api-response";
import type {
  Settings,
  TestEmailRequest,
  TestEmailResponse,
  ToggleMaintenanceRequest,
  UpdateSettingsRequest,
} from "@/types/settings";

export const settingsService = {
  async get(): Promise<Settings> {
    const response = await http.get(API_ENDPOINTS.SETTINGS.ROOT);
    return unwrapData<Settings>(response);
  },

  async update(payload: UpdateSettingsRequest): Promise<Settings> {
    const response = await http.put(API_ENDPOINTS.SETTINGS.ROOT, payload);
    return unwrapData<Settings>(response);
  },

  async toggleMaintenance(payload: ToggleMaintenanceRequest): Promise<Settings> {
    const response = await http.patch(
      API_ENDPOINTS.SETTINGS.MAINTENANCE,
      payload,
    );
    return unwrapData<Settings>(response);
  },

  async testEmail(payload: TestEmailRequest): Promise<TestEmailResponse> {
    const response = await http.post(API_ENDPOINTS.SETTINGS.EMAIL_TEST, payload);
    return unwrapData<TestEmailResponse>(response);
  },
};
